import React from 'react';
import {
  useFetch,
  Page,
  ApiSite,
  useUserinfo,
} from '@mss/mss-component-library';
import Breadcrumbs from '../common/Breadcrumbs';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import Settings from './views/Settings';
import Automations from './views/Automations';
import EditSidebar from './components/Sidebar';
import AddAutomation from './views/Automations/Add';
import EditAutomation from './views/Automations/Edit';
import EventLogAutomation from './views/Automations/Log';
import AssetConfiguration from './views/AssetConfiguration';
import { FormValuesContextProvider } from './contexts/FormValuesContext';
import Integrations from './views/Integrations';
import AddIntegration from './views/Integrations/Add';
import Workers from './views/Workers';
import OPCServers from './views/OPCServers';
import AddOPCServer from './views/OPCServers/Add';
const Configuration = () => {
  const { path, url } = useRouteMatch();
  const [status] = useFetch<ApiSite>({
    url: '/api/configuration/',
    defaultValue: {},
  });
  const [hasPermission] = useUserinfo();
  const permissions = {
    overview: hasPermission('view_configuration_site'),
    automations: hasPermission(['view_automation', 'change_automation']),
    assetConfiguration: hasPermission([
      'view_customfield',
      'change_customfield',
    ]),
    integrations: hasPermission('view_servicenowconfig'),
    workers: hasPermission('view_worker'),
    opcServers: hasPermission('view_opcservergroupconfig'),
  };
  return (
    <Page
      breadCrumbs={<Breadcrumbs />}
      main={
        <Switch>
          {permissions.overview && (
            <Route
              path={`${path}/settings`}
              render={() => <Settings status={status.data} />}
            />
          )}
          {permissions.automations && (
            <Route
              path={`${path}/automations/add`}
              render={() => (
                <FormValuesContextProvider>
                  <AddAutomation />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.automations && (
            <Route
              exact
              path={`${path}/automations/:automationId`}
              render={() => (
                <FormValuesContextProvider>
                  <EditAutomation />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.automations && (
            <Route
              path={`${path}/automations/:automationId/log`}
              render={() => (
                <FormValuesContextProvider>
                  <EventLogAutomation />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.integrations && (
            <Route
              exact
              path={`${path}/integrations`}
              render={() => (
                <FormValuesContextProvider>
                  <Integrations />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.integrations && (
            <Route
              path={`${path}/integrations/add`}
              render={() => (
                <FormValuesContextProvider>
                  <AddIntegration />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.integrations && (
            <Route
              path={`${path}/integrations/:integrationId`}
              render={() => (
                <FormValuesContextProvider>
                  <AddIntegration />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.workers && (
            <Route
              path={`${path}/workers/`}
              render={() => (
                <FormValuesContextProvider>
                  <Workers />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.opcServers && (
            <Route
              exact
              path={`${path}/opc-servers`}
              render={() => (
                <FormValuesContextProvider>
                  <OPCServers />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.opcServers && (
            <Route
              path={`${path}/opc-servers/add`}
              render={() => (
                <FormValuesContextProvider>
                  <AddOPCServer />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.opcServers && (
            <Route
              path={`${path}/opc-servers/:groupId`}
              render={() => (
                <FormValuesContextProvider>
                  <AddOPCServer />
                </FormValuesContextProvider>
              )}
            />
          )}
          {permissions.assetConfiguration && (
            <Route
              path={`${path}/asset-configuration`}
              component={AssetConfiguration}
            />
          )}
          {permissions.automations && (
            <Route path={`${path}/automations`} component={Automations} />
          )}
          {permissions.overview && (
            <Route render={() => <Redirect to={`${url}/settings`} />} />
          )}
          {permissions.automations && (
            <Route render={() => <Redirect to={`${url}/automations`} />} />
          )}
          {permissions.assetConfiguration && (
            <Route
              render={() => <Redirect to={`${url}/asset-configuration`} />}
            />
          )}
          {permissions.integrations && (
            <Route render={() => <Redirect to={`${url}/integrations`} />} />
          )}
          {permissions.workers && (
            <Route render={() => <Redirect to={`${url}/workers`} />} />
          )}
          {permissions.opcServers && (
            <Route render={() => <Redirect to={`${url}/opc-servers`} />} />
          )}
        </Switch>
      }
      sidebar={<EditSidebar />}
    />
  );
};

export default Configuration;
